export const notFoundEn = {};

export const notFoundFr = {};
